/* eslint class-methods-use-this: 0 no-param-reassign: 0 */

import { ModelPropertiesMapper } from 'jsona';

export default class SnakeModelPropertiesMapper extends ModelPropertiesMapper {
  camelCaseToSnakeCase(camelCasedValues) {
    const snakeValues = {};
    Object.keys(camelCasedValues).forEach((name) => {
      const snakeName = name.replace(/([a-z][A-Z])/g, g => `${g[0]}_${g[1].toLowerCase()}`);
      snakeValues[snakeName] = camelCasedValues[name];
    });
    return snakeValues;
  }

  getAttributes(model) {
    const camelCasedAttributes = super.getAttributes(model);
    return this.camelCaseToSnakeCase(camelCasedAttributes);
  }

  getRelationships(model) {
    const camelCasedRelationships = super.getRelationships(model);
    if (camelCasedRelationships) {
      return this.camelCaseToSnakeCase(camelCasedRelationships);
    }
    return camelCasedRelationships;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/data_formatter/snake_model_properties_mapper.js